import classNames from "classnames";
import React, { FC } from "react";

import FlintLogoSvg from "../../assets/images/FlintLogo.svg";
import { Image } from "../elements";
import "./Logo_flint.scss";

interface IFlintLogoProps {
	"data-testid"?: string;
	className?: string;
}

const FlintLogo: FC<IFlintLogoProps> = (props) => {
	return (
		<div
			data-testid={props["data-testid"] ?? "FlintLogoCntr"}
			className={classNames("LogoCntr", props.className)}
		>
			<Image src={FlintLogoSvg} alt="Flint QR Order" className="Logo" />
		</div>
	);
};

export default React.memo(FlintLogo);
